module.exports = __webpack_public_path__ + "img/shamanzs-animation-4.888095b2.gif";